import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * Fixed, non-interactive backdrop of three blurred brand orbs (spec §3).
 * Required for the glass surfaces to read as glass — they blur whatever sits
 * behind them. Rendered once at the top of the layout, below all content
 * (z-index:0, pointer-events:none). Orb drift is paused under
 * prefers-reduced-motion (spec §8).
 */
@Component({
  selector: 'app-glass-background',
  templateUrl: './glass-background.component.html',
  styleUrls: ['./glass-background.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GlassBackgroundComponent {}
